import { render } from "./Commodity.vue?vue&type=template&id=6f0a4634"
import script from "./Commodity.vue?vue&type=script&lang=js"
export * from "./Commodity.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__